export interface ErrorStateProps {
  children: React.ReactNode
}

export const ErrorState = ({ children, ...rest }: ErrorStateProps) => {
  return (
    <div
      className="w-full h-auto px-8 py-4 gap-4 grid place-content-center place-items-center bg-destructive/10 rounded-md"
      {...rest}
    >
      {children}
    </div>
  )
}
